import { FI } from './fi'

export const en: FI = {
  attachmentSelector: {
    title: 'Upload file',
    generalInfo: 'By clicking this area or dragging it here',
    restrictionsInfo:
      '(Max file size: 10 MB. Please Note! Banking Protection may prevent the uploading of attachments. You must disable the protection before uploading attachments. Supported formats: PDF, JPEG/JPG, PNG, DOC/DOCX, PPT/PPTX, and XLS/XLSX)',
    loading: 'Uploading...',
    error: {
      FileTooBig: 'File too big',
      InvalidExtension: 'File extension {{ext}} not allowed',
      InvalidMimeType: 'File format does not match file extension',
      MissingExtension: 'File extension missing',
      Unknown: 'Upload failed',
      nonEmptyArray: 'Missing attachment!',
      PublishFailure: 'The file cannot be attached to the application!'
    }
  },
  breadcrumb: {
    home: 'Home',
    YOUTH_PROJECT_GRANT: 'Targeted grants',
    YOUTH_GENERAL_GRANT: 'General grant'
  },
  common: {
    ok: 'Ok',
    cancel: 'Cancel',
    edit: 'Edit',
    modal: {
      defaultError: {
        title: 'Oops! Something went south',
        text: 'Check your network connection and try again after a while. If the problem persists, contact nuoriso@espoo.fi'
      },
      deleteApp: {
        title: 'Are sure you want to delete the application?',
        text: 'The application and its information will be removed from the system',
        confirmButtonLabel: 'Delete application'
      },
      sessionExpired: {
        title: 'Your session has expired',
        text: 'Click OK to log in again'
      },
      validationErrors: {
        title: 'Check fields'
      }
    },
    statuses: {
      DRAFT: 'Draft',
      SIGNING: 'Waiting for signature',
      SENT: 'Submitted',
      REVIEW: 'In review',
      PAYMENT_WAIT: 'Grant awarded',
      PRE_REPORT: 'Grant awarded',
      REJECTED: 'Not awarded',
      POST_REPORT: 'Grant awarded, paid',
      PAID: 'Grant awarded, paid',
      RECOVERY: 'Recovery',
      RECOVERED: 'Recovered'
    }
  },
  footer: {
    cityOfEspoo: 'City of Espoo',
    privacyPolicy: 'Privacy policy',
    a11yStatement: 'Accessibility statement',
    feedback: 'Give feedback'
  },
  header: {
    nav: {
      logout: 'Sign out'
    },
    title: {
      label: 'Youth grant'
    }
  },
  org: {
    additionalInfo: {
      title: 'Complementary information about the association',
      activity: {
        label: 'Activity',
        values: {
          EARLY_YOUTH_ACTIVITIES: 'Activities for early youths',
          HOBBY_CLUBS: 'Hobby clubs',
          POLITICAL: 'Political youth and student activities',
          SCOUT: 'Scout',
          SPIRITUAL: 'Spiritual activities',
          OTHER: 'Other youth activities'
        }
      },
      targetGroup: {
        label: 'Target group',
        values: {
          ALL: 'All',
          BOYS: 'Boys',
          GIRLS: 'Girls'
        }
      },
      members: {
        info: {
          label:
            'Number of organisation members (citizens of Espoo, in the start of the current year)'
        },
        from21to28: {
          label: '21–28 years'
        },
        from29: {
          label: '29 years and over'
        },
        from7to20: {
          label: '7–20 years'
        },
        total: {
          label: 'Total members'
        }
      }
    },
    address: {
      postalAddress: {
        label: 'Postal address'
      },
      postalCode: {
        label: 'Postal code'
      },
      postOffice: {
        label: 'Post office'
      }
    },
    areas: {
      label: 'Operation area',
      values: {
        SUUR_ESPOONLAHTI: 'Suur-Espoonlahti',
        SUUR_LEPPAVAARA: 'Suur-Leppävaara',
        SUUR_MATINKYLA: 'Suur-Matinkylä',
        SUUR_TAPIOLA: 'Suur-Tapiola',
        SUUR_KAUKLAHTI: 'Suur-Kauklahti',
        VANHA_ESPOO: 'Vanha-Espoo',
        POHJOIS_ESPOO: 'Pohjois-Espoo',
        OUTSIDE_OF_ESPOO: 'Outside of Espoo'
      }
    },
    bankAccount: {
      label: 'IBAN'
    },
    basicInfo: {
      label: 'Community details'
    },
    businessId: {
      label: 'Business id'
    },
    domicile: {
      label: 'Domicile'
    },
    email: {
      label: 'Email'
    },
    name: {
      label: 'Community name'
    },
    registrationDate: {
      label: 'Registration date'
    },
    representativeRole: {
      CHAIRMAN: 'Main representative',
      SIGNER: 'Representative'
    },
    representatives: {
      label: 'Representatives of the community'
    },
    requiredSignersAmount: {
      label:
        'Minimum number of persons authorised to sign on behalf of the community'
    },
    type: {
      label: 'Community type',
      ASSOCIATION: 'Association',
      COMPANY: 'Company',
      FOUNDATION: 'Foundation'
    },
    wwwAddress: {
      label: 'Web address'
    }
  },
  validations: {
    dateWithinRange: 'Value must be between {{start}} - {{end}}',
    greaterThanOrEqual: 'Value must be {{min}} or greater',
    notNil: 'Value is missing',
    required: 'Mandatory field',
    withinRange: 'Must be between {{min}}{{unit}} - {{max}}{{unit}}',
    attachmentsRequired: 'At least {{min}} attachment is required'
  },
  views: {
    generalGrant: {
      form: {
        title: 'General grant',
        appDetails: {
          title: 'Grant details',
          detailsOfUse:
            'Intended use of the grant for which you are applying (main points only)',
          appliedSumInCents: 'Applied sum'
        },
        participants: {
          title: 'Number of attendances by Espoo residents last year',
          desc_1: 'How many Espoo residents have attended your events?',
          desc_2:
            'Example 1: The club was held three times a week, and each club had 20 participants. The club was held on 40 weeks during the year. The total number of attendances was 2,400.',
          desc_3:
            'Example 2: The camp lasted three days. The camp had 20 participants per day. The camp had a total of 60 attendances.',
          from7to20: '7–20 years',
          from21to28: '21–28 years',
          total: 'Total number of attendances:'
        },
        goals: {
          title:
            'Objectives of the community’s activities for the current year',
          goals_1: 'Goal 1',
          goals_2: 'Goal 2',
          goals_3: 'Goal 3'
        },
        youngEspoo: {
          link: 'https://www.espoo.fi/en-US/youth',
          title_1: 'How do the community activities implement ',
          title_link: 'the Young Espoo',
          title_2: ' story?'
        },
        financialPlan: {
          label: 'Community fundraising plan for the current year ',
          placeholder:
            'Community fundraising refers to grants applied for from different sources, ticket revenue, sales revenue, membership fees etc.'
        },
        previousYear: {
          title: 'Last year’s finances',
          totalProfitInCents: 'Profit/loss for the accounting period, EUR',
          bankAccountSumInCents:
            'Bank balance on {{lastDayOfPreviousYear}} in EUR',
          selfAcquiredFundsInCents: 'Own fundraising',
          receivedGrants: {
            label: 'Grants received from the City of Espoo and other sources',
            placeholder: 'Name of source and amount in EUR'
          }
        },
        attachments: {
          title: 'Attachments',
          mandatoryAttachments: {
            title: 'Attach the following mandatory attachments *:',
            planForYear: 'Operating plan for {{year}}',
            budgetForYear: 'Budget for {{year}}',
            minutesOfAnnualMeeting:
              'Extract from the minutes of the {{year}} annual meeting',
            annualReport: 'Adopted annual report for {{year}}',
            financialStatemment: 'Approved financial statement for {{year}}',
            auditForAYear: 'Performance audit for {{year}}'
          }
        },
        signing: {
          title: 'Signing',
          info: 'On the signature page, you can check the information you have provided before signing the application.'
        }
      },
      preview: {
        appDetails: 'Grant details',
        detailsOfUse: 'Intended use of the grant for which you are applying',
        appliedSum: 'Amount of the annual grant applied for, EUR',
        activity: {
          label: 'Activity',
          values: {
            EARLY_YOUTH_ACTIVITIES: 'Activities for early youths',
            HOBBY_CLUBS: 'Hobby clubs',
            POLITICAL: 'Political youth and student activities',
            SCOUT: 'Scout',
            SPIRITUAL: 'Spiritual activities',
            OTHER: 'Other youth activities'
          }
        },
        members: {
          label: 'Members',
          from7to20: 'Members 7–20',
          from21to28: 'Members 21–28 years',
          total: 'Total number of members:'
        },
        participants: {
          label: 'Attendances',
          from7to20: 'Attendances 7-20',
          from21to28: 'Attendances 21-28',
          total: 'Total number of attendances:'
        },
        goals: {
          goals_1: 'Goal 1',
          goals_2: 'Goal 2',
          goals_3: 'Goal 3'
        },
        youngEspoo: 'Implementation of the Young Espoo story',
        financialPlan: 'Fundraising',
        previousYear: {
          title: 'Last year’s finances',
          totalProfitInCents: 'Profit/loss for the accounting period',
          bankAccountSumInCents: 'Bank balance on {{lastDayOfPreviousYear}}',
          selfAcquiredFundsInCents: 'Own fundraising',
          receivedGrants: 'Grants received'
        }
      }
    },
    form: {
      appDetails: {
        title: 'Grant details',
        text: 'Fill in the information and attendants for the applied project grant. Fields marked with * are required.',
        event: {
          name: 'Use of grant',
          location: 'Location',
          startDate: 'Activity start date',
          endDate: 'Activity end date'
        },
        purpose: 'More accurate description of the intended use',
        appliedTotal: 'Sum €',
        numberOfParticipants:
          'Estimated / actual number of participants living in Espoo',
        participants: {
          ages7to20: {
            label: '7–20 years'
          },
          ages21to28: {
            label: '21–28 years'
          },
          ages29andOver: {
            label: '29 years and over'
          },
          total: {
            label: 'Total'
          }
        },
        totalParticipants: 'Total number of participants'
      },
      attachments: {
        title: 'Attachments',
        text: 'Add the attachments you want, e.g, copies of receipts.'
      },
      delete: {
        title: 'Are sure you want to delete the application?',
        text: 'The application and its information will be removed from the system',
        action: 'Remove application'
      },
      expensesAndIncomes: {
        title: 'Expenses and incomes',
        expenses: {
          description: 'Expense (description)',
          amount: 'Sum €',
          totalSum: 'Total expenses:',
          delete: 'Remove expense',
          add: 'Add row',
          title: 'Expenses'
        },
        incomes: {
          description: 'Income (description)',
          amount: 'Sum €',
          totalSum: 'Total incomes:',
          delete: 'Remove income',
          add: 'Add row',
          title: 'Incomes'
        }
      },
      newApplication: 'New application',
      orgInfo:
        "Confirm that the the community's and signatories' contact information are correct. Add complementary information about the the community. * The fields marked with a star are mandatory.",
      saveAndClose: 'Save and close',
      signing: {
        title: 'Signature',
        text: 'On the signature page, you can check the information you have provided before signing the application.'
      },
      toSigning: 'Move to signing'
    },
    home: {
      orgs: {
        title: 'Registered communities',
        createOrgAction: 'Add a community'
      },
      org: {
        apps: {
          actions: {
            open: 'Open application',
            delete: 'Delete application'
          },
          columns: {
            grantPeriod: 'Application period',
            eventName: 'Use of grant',
            status: 'State',
            workgroupEventLabel: 'working group',
            appliedSum: 'Applied',
            decisionSum: 'Decision'
          },
          statusDesc: {
            payImmediately: 'Paid immediately',
            postReportApproved: 'Report approved',
            postReportPaymentWait:
              'Paid immediately, provide report by {{dueDate}}',
            postReportPending: 'Waiting for report by {{dueDate}}',
            preReportApproved: 'Report approved, paid {{amount}} €',
            preReportRejected: 'Report rejected',
            preReportWait: 'Provide report by {{dueDate}}',
            recovery: 'Report rejected, repay {{amount}} € by {{dueDate}}',
            recovered: 'Repaid {{amount}} €'
          }
        },
        applyForGrant: {
          title: 'Apply for a project grant',
          date: 'by {{date}}',
          titleAndDate: 'Apply for a project grant by {{date}}',
          YOUTH_PROJECT_GRANT: 'Apply for a project grant',
          YOUTH_GENERAL_GRANT: 'Apply for a general grant'
        },
        incompleteApps: 'Incomplete applications: {{count}}',
        showDetails: 'View applicant information'
      }
    },
    landing: {
      browserSupport: {
        unsupportedBrowser: 'Your browser is not supported.',
        info: 'The system only supports the newest versions of Chrome and Firefox.'
      },
      welcome: {
        title: 'Welcome to apply for youth grant!',
        subtitle: 'Sign in using Suomi.fi e-Identification!',
        button: 'Suomi.fi e-Identification'
      }
    },
    preview: {
      attachments: {
        app: {
          title: 'Attachments'
        },
        report: {
          title: 'Report attachments'
        }
      },
      close: 'Close',
      expensesAndIncomes: {
        title: 'Expenses and incomes',
        expenses: {
          total: 'Expenses total:',
          title: 'Expenses'
        },
        incomes: {
          total: 'Incomes total:',
          title: 'Incomes'
        }
      },
      processSteps: {
        APPLICATION: {
          title: 'Application'
        },
        DECISION: {
          title: 'Decision',
          REVIEW: 'In review',
          REJECTED: 'Rejected',
          GRANTED_PAY_IMMEDIATELY: 'Granted {{amount}} €, paid immediately',
          GRANTED_PAY_IMMEDIATELY_WAIT_REPORT:
            'Granted {{amount}} €, waiting for the report',
          GRANTED_PAY_AFTER_REPORT:
            'Granted {{amount}} €, paid after the report'
        },
        PRE_REPORT: {
          title: 'Report',
          PENDING: 'By {{dueDate}}',
          APPROVED: 'Report approved, paid {{amount}} €',
          REJECTED: 'Report rejected'
        },
        PAYMENT: {
          title: 'Payment',
          PAID: 'Paid {{amount}} €',
          REJECTED: 'Not paid',
          ACTIVE: 'In process'
        },
        POST_REPORT: {
          title: 'Report',
          ACTIVE: 'By {{dueDate}}',
          APPROVED: 'Report approved',
          REJECTED: 'Report rejected'
        },
        RECOVERY: {
          title: 'Recovery',
          PENDING:
            'Report rejected, recovery, repay {{amount}} € by {{dueDate}}',
          COMPLETED: 'Repaid {{amount}} €'
        }
      },
      signing: {
        signedAt: 'Signed: {{date}}'
      }
    },
    signing: {
      await: {
        title:
          'The signature has been added! The application requires yet another signature.',
        text: 'Another representative must log in to the service and sign the application',
        controls: {
          confirm: 'ok'
        }
      },
      close: 'Close',
      confirm: {
        title: 'You are about to sign the application',
        text: {
          sendAfterSign:
            "After the signing, the application will be submitted. A submitted application can't be edited anymore.",
          awaitAfterSign:
            'After the signing, the application will wait for another signature'
        },
        controls: {
          cancel: 'Cancel',
          confirm: 'Sign'
        }
      },
      edit: 'Edit application',
      link: {
        label: 'Grant guidelines',
        url: 'https://www.espoo.fi/fi/nuorisoavustukset#section-19216'
      },
      org: {
        check:
          'I confirm that the community’s information and the information contained in the application form are correct. I am over 18 years old and I have the right to sign the application on behalf of the community.',
        notConfirmed: {
          title: 'Community and application information has not been confirmed',
          text: 'Please check the community’s information and the information contained in the application form. Then confirm them by selecting the checkbox “I confirm that the community’s information and the information contained in the application form are correct”.'
        },
        signers:
          'Representatives authorized to sign on behalf of the community:',
        signingInfo:
          'By signing this application, the applicant agrees to provide a comprehensive statement of the realisation of the community’s finances, by the date specified in the grant decision. The applicant also agrees to return the grant sum if they fail to follow the instructions on the grants of the Sports and Exercise and Youth Committee (',
        signingInfo2:
          '). The applicant also agrees to keep their accounts and administration open for auditing by the City of Espoo.'
      },
      orgInfo:
        "Confirm that the community's and signatories' contact information are correct.",
      sign: 'Sign',
      success: {
        title: 'The application has been signed and submitted',
        text: 'NB! This version of the service will not send any email confirmations of the reception and processing of the application',
        controls: {
          confirm: 'ok'
        }
      }
    }
  }
}
